// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__r7DcK","header":"ReportDetails_header__gHveZ","title":"ReportDetails_title__32iAu","left":"ReportDetails_left__3ytS0"};